import { render, staticRenderFns } from "./ContestDetail.vue?vue&type=template&id=2b2a27d2&scoped=true&"
import script from "./ContestDetail.vue?vue&type=script&lang=ts&"
export * from "./ContestDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ContestDetail.vue?vue&type=style&index=0&id=2b2a27d2&lang=scss&scoped=true&"
import style1 from "./ContestDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a27d2",
  null
  
)

export default component.exports